import { goToHomePage } from '../services/auth';
import React from 'react';

const Index = () => {
  goToHomePage();
  return <></>;
};

export default Index;
